import { render, staticRenderFns } from "./ProgramsListTable.vue?vue&type=template&id=af1e63e6&scoped=true&"
import script from "./ProgramsListTable.vue?vue&type=script&lang=js&"
export * from "./ProgramsListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsListTable.vue?vue&type=style&index=0&id=af1e63e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1e63e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRating } from 'vuetify/lib/components/VRating';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VRating,VSelect,VSimpleTable})
